import { useEffect } from 'react';
import SplashScreen from 'react-native-splash-screen';
import { clearToken } from '../api';

export const useRouting = () => {
  useEffect(() => {
    clearToken().then(SplashScreen.hide);
  }, []);

  return {
    initialRouteName: 'requiredToSignUp',
  };
};
